import React, { Component } from 'react';
import PropTypes from 'prop-types';
/** Component */
import CamaraModal from '../components/camaraModal';
import MapaHeader from '../components/mapaHeader';
import Mapa from '../components/mapa';
/** Services */
import { getCurrentUser } from '../utils/services/authService';
import { getTowerFloors } from '../utils/services/towerService';
import { getAccessibleDoors, getDoorsStatusesByBuildingId } from '../utils/services/doorService';
import { showErrorAlert } from '../utils/alerts';
import socket from '../utils/socket';
import { getUnifiedDoorStatus } from '../utils/getUnifiedDoorStatus';

export class Camaras extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buildingId: null,
      buildingName: null,
      options: {},
      selected: {},
      doorSelected: null,
    };
  }

  async componentDidMount() {
    try {
      const buildingIdFromRoute = this.props.match?.params?.buildingId;
      const building = this.props.location?.state || null;

      await this.setInitialData(building, buildingIdFromRoute);

      const { buildingId } = this.state;
      if (buildingId) {
        socket.emit("subscribe:door_status", { buildingId });

        socket.on(`door_update_${buildingId}`, ({ doorId, event }) => {
          const unifiedConfig = getUnifiedDoorStatus(event);
          const doorStatus = unifiedConfig.unifiedKey || event.eventType;

          this.updateDoorState(doorId, doorStatus);
          localStorage.setItem(`door_${doorId}_status`, doorStatus);
        });
      }
    } catch (error) {
      showErrorAlert('Error', error.message);
    }
  }

  componentWillUnmount() {
    const { buildingId } = this.state;
    if (buildingId) {
      socket.emit('leave:cam_stream', { buildingId });
      socket.off(`door_update_${buildingId}`);
    }
  }

  updateDoorState(doorId, eventType) {
    const { options, selected } = this.state;

    const updatedDoors = options.doors.map((door) =>
      door.id === doorId ? { ...door, state: eventType } : door
    );

    const updatedSelectedDoors = selected.doors.map((door) =>
      door.id === doorId ? { ...door, state: eventType } : door
    );

    this.setState({
      options: { ...options, doors: updatedDoors },
      selected: { ...selected, doors: updatedSelectedDoors },
    });
  }

  async setInitialData(buildingData, buildingIdFromRoute) {
    try {
      let building = buildingData;

      const token = localStorage.getItem('authToken');

      if (!buildingData && buildingIdFromRoute) {
        building = { id: buildingIdFromRoute };
      } else if (!buildingData) {
        const { data } = await getCurrentUser(token);
        building = data.spaces?.[0]?.building;

        if (!building) {
          throw new Error('No se encontró un edificio asociado al usuario.');
        }
      }

      const doors = await getAccessibleDoors(building.id, token);

      if (!doors.length) {
        throw new Error(`No se encontraron puertas para el edificio '${building.name || building.id}' .`);
      }

      const doorStatuses = await getDoorsStatusesByBuildingId(building.id);

      const doorsWithStatus = doors.map((door) => {
        const reportedStatus = doorStatuses?.[door.id]?.eventType;
        const cachedStatus = localStorage.getItem(`door_${door.id}_status`);

        return {
          ...door,
          state: reportedStatus || cachedStatus  || door.state || null
        };
      });

      const { tower } = doors[0];
      const { data: floors } = await getTowerFloors(tower.id);

      if (!floors.length) {
        throw new Error(`No se encontraron pisos para la torre '${tower.name}'.`);
      }

      const options = {
        tower,
        floors: floors || [],
        doors: doorsWithStatus || [],
      };

      const floor = floors[0] || null;
      const selected = {
        floor,
        doors: floor ? doorsWithStatus.filter((door) => door?.floor?.id === floor?.id) : [],
      };

      this.setState({
        options,
        selected,
        buildingId: building.id,
        buildingName: building.name || ''
      });
    } catch (error) {
      const message = error.message || JSON.stringify(error);
      console.error(message);
      showErrorAlert(
        '!Ups¡ Error al cargar los datos',
        `Hubo un problema al obtener la información necesaria. Motivo: ${message}`,
      );
    }
  }

  handleFloorChanged(floorId) {
    if (floorId) {
      const floor = this.state.options.floors.find((floor) => floor.id === floorId);
      const doors = this.state.options.doors.filter((door) => door && door.floor && door.floor.id === floor.id);
      const selected = {
        floor,
        doors,
      };
      this.setState({
        selected,
      });
    }
  }

  handleCloseModal() {
    this.setState({
      doorSelected: null,
    });
  }

  updateCamera(door) {
    this.setState({
      doorSelected: door,
    });
  }

  render() {
    const { buildingId, buildingName, doorSelected, options, selected } = this.state;

    return (
      <div className="camaras-container">
        {options.floors && options.floors.length > 1 && (
          <MapaHeader
            selection={selected}
            floors={options.floors}
            label="Selecciona el nivel que quieres ver."
            onFloorChanged={this.handleFloorChanged.bind(this)}
          />
        )}
        <div className="mapa">
          <div className="image-container">
            <img className="mapa-img" alt="" src={selected && selected.floor && selected.floor.image} />

            {selected &&
              selected.doors &&
              selected.doors.map((door) => (
                <Mapa
                  key={door.id}
                  door={door}
                  doorId={door.id}
                  camId={door.cameraId}
                  cam01Left={door.left}
                  cam01Top={door.top}
                  nameCamara={door.name}
                  datatoggle="modal"
                  datatarget="#video01"
                  cameraSelected={this.updateCamera.bind(this)}
                  doorStatus={door.state}
                />
              ))}
          </div>
        </div>
        {doorSelected && (
          <CamaraModal
            door={doorSelected}
            buildingId={buildingId}
            buildingName={buildingName}
            onModalClosed={this.handleCloseModal.bind(this)}
          />
        )}
      </div>
    );
  }
}

Camaras.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      buildingId: PropTypes.string,
    }),
  }),
  history: PropTypes.object.isRequired,
};

export default Camaras;